import { BaseComponent } from '../../base-component';
import { getBenefitData } from '../../_common/client/installment-plan';
import { InstallmentExampleTextDetails } from '../types';
import { benefitEvents } from '@otto-ec/nexus-registry/benefit/events';
import { Unset } from '@otto-ec/global-resources/nexus';
import { BenefitData } from '../../_common/types/benefit';

export class InstallmentPlanExampleComponent extends BaseComponent {
    public rootSelector = '.js_pdp_installment-plan-example';
    public priceSelector = '.js_pdp_installment-plan-example__example-price';
    public postPriceSelector = '.js_pdp_installment-plan-example__example-post-price';
    private benefitListenerUnset?: Unset | null;

    public async onHtmlLoaded(): Promise<void> {
        if (this.benefitListenerUnset) {
            this.benefitListenerUnset();
        }

        if (!this.isPresent()) {
            return;
        }

        this.registerFT9BenefitActiveEvent();
    }

    private registerFT9BenefitActiveEvent(): void {
        this.benefitListenerUnset = benefitEvents.active.subscribe(benefit => {
            this.updateTextOnBenefitEvent(benefit);
        });
    }

    private updateTextOnBenefitEvent(benefit: BenefitData): void {
        if (!benefit.id || !benefit.active || !benefit.variationId || benefit.variationId !== this.getVariationId()) {
            return;
        }
        const rootElement: HTMLElement = this.getRootElement();
        const benefitData: InstallmentExampleTextDetails[] = getBenefitData(rootElement);

        const text = benefitData.find(b => b.benefitId === `${benefit.id}`);
        if (!text) {
            return;
        }

        this.updateText(rootElement, this.priceSelector, text.price);
        this.updateText(rootElement, this.postPriceSelector, text.postPrice);
    }

    private updateText(htmlRootElement: HTMLElement, selector: string, text: string) {
        const htmlElement = htmlRootElement.querySelector<HTMLElement>(selector);
        if (!htmlElement) {
            throw new Error(`${selector} could not be found`);
        }

        htmlElement.innerText = text;
    }
}
